import { render, staticRenderFns } from "./layoutBlank.vue?vue&type=template&id=711e3b20&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('711e3b20')) {
      api.createRecord('711e3b20', component.options)
    } else {
      api.reload('711e3b20', component.options)
    }
    module.hot.accept("./layoutBlank.vue?vue&type=template&id=711e3b20&", function () {
      api.rerender('711e3b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layoutBlank.vue"
export default component.exports